/// <amd-module name="Artifacts/Root/helpers/ComponentStateHelpers" />

import { ComponentState, ComponentStatus } from "Artifacts/Root/Constants";

export const ReadyComponentState = (): ComponentState => {
  return { status: ComponentStatus.Ready };
};

export const LoadingComponentState = (): ComponentState => {
  return { status: ComponentStatus.Loading };
};

export const ErrorComponentState = (errorMessage: string): ComponentState => {
  return { status: ComponentStatus.Error, errorMessage };
};

export const isReady = (state: ComponentState): boolean => {
  return state.status === ComponentStatus.Ready;
};

export const isLoading = (state: ComponentState): boolean => {
  return state.status === ComponentStatus.Loading;
};

export const isError = (state: ComponentState): boolean => {
  return state.status === ComponentStatus.Error;
};
